import { Component, OnInit } from '@angular/core';
import { OktaService } from '../../okta.service';
import { NgForm } from '@angular/forms';
import { HttpError } from '../../../../shared/models/http-error';
import { UserProperty, CacheConstant } from '../../../../core/constants/app.constant';
import { AppUtilService } from '../../../../core/utils/app-util.service';
import { PublisherService } from '../../../../core/services/publisher.service';
import { UserService } from '../../../../core/services/user.service';
import { OktaConstant } from '../../okta.constant';
import { AppCacheService } from '../../../../core/services/cache/app-cache.service';
import { BaseComponent } from '../../../../../app/app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfigService } from '../../../../core/services/init/app-config.service';

@Component({
  selector: 'par-security-question-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateComponent extends BaseComponent implements OnInit {
  /***************Properties***************/
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  private oktaRecoveryQuestion = this.userService.getProperty(
    UserProperty.OktaRecoveryQuestions
  );
  securityQuestions: Array<any> = new Array<any>();
  validation = {
    regex: OktaConstant.SecurityAnswer.LengthRegex,
    minLength: OktaConstant.SecurityAnswer.MinLength,
    infoMessage: OktaConstant.SecurityAnswer.ValidationMessage
  };
  update: any = {
    question: '',
    answer: '',
    confirmAnswer: '',
    errorMessage: ''
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    private oktaService: OktaService,
    private userService: UserService,
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService
  ) { super(deviceDetectorService, cache, appConfig);}

  ngOnInit() {
    PublisherService.changeBannerHeader('Change Security Question');
    this.getSecurityQuestions();
    if (this.oktaRecoveryQuestion && this.oktaRecoveryQuestion.question) {
      this.update.question = this.oktaRecoveryQuestion.question;
    }
  }
  /***************Constructor***************/

  onCancelClick() {
    AppUtilService.redirectToHome();
  }

  onSecurityQuestionSubmit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    this.update.errorMessage = '';

    this.oktaService
      .updateSecurityQuestion(this.update.question, this.update.answer)
      .subscribe((response: any) => {
        if (response && response.hasError) {
          this.update.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        } else {
          this.oktaRecoveryQuestion.question = this.update.question;
          this.userService.updateProperty(
            UserProperty.OktaRecoveryQuestions,
            this.oktaRecoveryQuestion
          );
          AppUtilService.message.success(
            OktaConstant.Messages.SecurityQuestionUpdatedMesssage
          );
          AppUtilService.redirectToHome();
        }
      });
  }

  /***************Private Methods***************/

  private getSecurityQuestions() {
    this.oktaService.getSecurityQuestions().subscribe((response: any) => {
      if (!response.hasError) {
        this.securityQuestions = response;
      }
    });
  }

  /***************Private Methods***************/
}
